import React from 'react'
import type { EmptyContentProps } from '@ztechapps/webui.util'
import { EmptyContent as CoreEmptyContent } from '@ztechapps/webui.util'

export const EmptyContent = (props: EmptyContentProps) => {
  return (
    <CoreEmptyContent
      message="You don't have any conversation yet."
      subMessage="When you or the other party starts conversation you will see all the messages here."
      icon="comments"
      {...props}
    />
  )
}
